import { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { animated, useSpring, useSprings } from '@react-spring/web'
import { Link, Outlet } from 'react-router-dom'
import Metadata from '../../utils/metadata'
import style from './Laboratory.module.scss'
import { labItems } from './LaboratoryItems'
import Icon from 'components/Icon/Icon'

function Laboratory(): JSX.Element {
  const { t } = useTranslation(['laboratory'])

  const _spring_container = useSpring({
    from: { opacity: 0, transform: 'translateY(10%)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  })

  const filteredLabs = useMemo(() => {
    return labItems.filter((lab) => {
      return labItems
    })
  }, [])

  const _spring_laboratory_list = useSprings(
    filteredLabs.length,
    filteredLabs.map((_, index) => ({
      from: { opacity: 0, transform: 'translateY(15%)' },
      to: { opacity: 1, transform: 'translateY(0)' },
      delay: 70 * index,
    }))
  )
  return (
    <>
      <Metadata
        title={`${t('title')} | ${t('website.title', {
          ns: 'common',
        })}`}
        description={t('description')}
      />
      <div className={style.laboratory}>
        <animated.div className={style.container} style={_spring_container}>
          <div className={style.header}>
            <p>{t('description')}</p>
          </div>

          <div className={style.tools_grid}>
            {filteredLabs.length > 0 ? (
              filteredLabs.map((lab, index) => (
                <animated.li
                  key={lab.title}
                  style={_spring_laboratory_list[index]}
                >
                  <Link to={lab.path} className={style.tool_card}>
                    <div
                      className={style.background}
                      style={{
                        background: lab.backgroundColor
                          ? `linear-gradient(115deg, ${lab.backgroundColor.join(
                              ','
                            )})`
                          : undefined,
                        backgroundImage: lab.backgroundImage
                          ? `url(${lab.backgroundImage})`
                          : undefined,
                      }}
                    >
                      <Icon name={lab.icon} size="lg" />
                    </div>

                    <div className={style.tool_content}>
                      <div className={style.status_container}>
                        <div className={style.status}>
                          {lab.status?.isNew && (
                            <span className={style.new}>{t('status.new')}</span>
                          )}
                          {lab.status?.isPopular && (
                            <span className={style.popular}>
                              {t('status.popular')}
                            </span>
                          )}
                          {lab.status?.wip && (
                            <span className={style.wip}>{t('status.wip')}</span>
                          )}
                        </div>

                        {lab.tags && (
                          <div className={style.tags}>
                            {lab.tags.map((tag, idx) => (
                              <span key={idx} className={style.tag}>
                                {t(`tags.${tag}`)}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>

                      <h2>{t(`tools.${lab.title}`)}</h2>
                      <p>{t(`tools.${lab.description}`)}</p>
                    </div>
                  </Link>
                </animated.li>
              ))
            ) : (
              <div className={style.no_results}>{t('no_results')}</div>
            )}
          </div>
        </animated.div>
      </div>
      <Outlet />
    </>
  )
}

export default Laboratory
